import { getUrlPrefixFromView } from '../../../infra/routing';
import { buildCampaignStateFromApiData } from '../campaign-builder/model-mapping/mapper';
import { validate } from '../campaign-builder/validations/validate';
import { validateContent } from '../campaign-builder/validations/content';
import { validateSchedule } from '../campaign-builder/validations/schedule';
import { validateAudiences } from '../campaign-builder/validations/audiences';
import { validatePromoId } from '../campaign-builder/validations/promo-id';
import { validateImages } from '../campaign-builder/validations/images';
import { isDraft } from '../campaign-utils';
var baseUrlV1 = '/engagement';
var baseUrlV2 = '/engagement-v2';
var withBaseBuilderUrl = function (path, params) {
    var prefix = getUrlPrefixFromView(params.session.view);
    return "".concat(prefix).concat(baseUrlV2, "/").concat(params.campaignId || 'new').concat(path);
};
export var buildCampaignTypeUrl = function (params) {
    return withBaseBuilderUrl("/type", params);
};
export var buildCampaignConfigurationUrl = function (params) {
    return withBaseBuilderUrl("/configuration", params);
};
export var buildCampaignContentUrl = function (params) {
    return withBaseBuilderUrl("/content", params);
};
export var buildCampaignReviewUrl = function (params) {
    return withBaseBuilderUrl("/review", params);
};
export var buildCampaignViewUrl = function (params) {
    return withBaseBuilderUrl("/view", params);
};
export var buildCampaignListUrl = function (params) {
    var prefix = getUrlPrefixFromView(params.session.view);
    return "".concat(prefix).concat(baseUrlV1);
};
var buildCampaignV1DraftUrl = function (params) {
    var baseUrl = buildCampaignListUrl(params);
    return "".concat(baseUrl, "/").concat(params.campaignId);
};
var buildCampaignV1ViewUrl = function (params) {
    var baseUrl = buildCampaignListUrl(params);
    return "".concat(baseUrl, "/").concat(params.campaignId, "/view");
};
export var buildCampaignUrlFromList = function (params) {
    if (params.campaign.version === 1) {
        if (isDraft(params.campaign)) {
            return buildCampaignV1DraftUrl({ session: params.session, campaignId: params.campaign.id });
        }
        return buildCampaignV1ViewUrl({ session: params.session, campaignId: params.campaign.id });
    }
    var activeCampaignState = buildCampaignStateFromApiData({ campaign: params.campaign, session: params.session });
    // in this context we might not have an active campaign in the store, so we need to mock it
    var emulatedStore = {
        getState: function () { return ({
            engagement: {
                engageV2: {
                    activeCampaign: activeCampaignState,
                },
            },
        }); },
    };
    var configurationValidationResults = validate({ store: emulatedStore }, [
        validatePromoId,
        validateAudiences,
        validateSchedule,
    ]);
    if (!configurationValidationResults.isValid || params.isDuplicateCampaign) {
        return buildCampaignConfigurationUrl({ session: params.session, campaignId: params.campaign.id });
    }
    var contentValidationResults = validate({ store: emulatedStore }, [validateContent, validateImages]);
    if (!contentValidationResults.isValid) {
        return buildCampaignContentUrl({ session: params.session, campaignId: params.campaign.id });
    }
    if (isDraft(params.campaign)) {
        return buildCampaignReviewUrl({ session: params.session, campaignId: params.campaign.id });
    }
    return buildCampaignViewUrl({ session: params.session, campaignId: params.campaign.id });
};
